import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  loadingSurveyList: false,
  saveLoader: false,
  surveyLength: 0,
  survey: [],
  surveyList: [],
}

export default function SurveyReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_SURVEY:
      return {...state, loading: action.payload}
    case actions.LOADING_SURVEYS:
      return {...state, loadingSurveyList: action.payload}
    case actions.SAVE_LOADER_SURVEY:
      return {...state, saveLoader: action.payload}
    case actions.GET_SURVEY:
      return {...state, survey: action.payload.survey}
    case actions.GET_SURVEYS:
      return {...state, surveyList: action.payload.surveyList, surveyLength: action.payload.surveyLength}
    default:
      return {...state};
  }
}